export default __webpack_public_path__ + "static/media/lemons-leaves-no-shadow@3x.541245e9.png";